import { useEffect, useState } from 'react';
import { prestamoService } from '../../services/api';
import '../../styles/Reportes.css';

const PrestamosRealizados = () => {
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [prestamos, setPrestamos] = useState([]);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    // Establecer fechas por defecto (mes actual)
    const hoy = new Date();
    const primerDia = new Date(hoy.getFullYear(), hoy.getMonth(), 1);

    setFechaInicio(primerDia.toISOString().split('T')[0]);
    setFechaFin(hoy.toISOString().split('T')[0]);
  }, []);

  const cargarPrestamos = async () => {
    if (!fechaInicio || !fechaFin) {
      alert('Por favor selecciona ambas fechas');
      return;
    }

    setCargando(true);
    try {
      const response = await prestamoService.getAll();
      const todos = response.data.prestamos || [];

      // Filtrar por rango de fechas
      const filtrados = todos.filter(p => {
        const fechaPrestamo = new Date(p.fecha_inicio);
        const inicio = new Date(fechaInicio);
        const fin = new Date(fechaFin);
        fin.setHours(23, 59, 59); // Incluir todo el día final

        return fechaPrestamo >= inicio && fechaPrestamo <= fin;
      });

      // Ordenar por fecha descendente
      filtrados.sort((a, b) => new Date(b.fecha_inicio) - new Date(a.fecha_inicio));

      setPrestamos(filtrados);
    } catch (error) {
      alert('Error al cargar préstamos');
      console.error(error);
    } finally {
      setCargando(false);
    }
  };

  const formatearFecha = (fecha) => {
    return new Date(fecha).toLocaleDateString('es-DO', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  };

  const calcularTotales = () => {
    const totalPrestado = prestamos.reduce((sum, p) => sum + p.monto_prestado, 0);
    const totalCapital = prestamos.reduce((sum, p) => sum + p.capital, 0);
    const totalInteres = prestamos.reduce((sum, p) => sum + p.interes, 0);
    const totalGeneral = prestamos.reduce((sum, p) => sum + p.total, 0);

    // Contar por modalidad
    const porModalidad = prestamos.reduce((acc, p) => {
      acc[p.modalidad] = (acc[p.modalidad] || 0) + 1;
      return acc;
    }, {});

    return { totalPrestado, totalCapital, totalInteres, totalGeneral, porModalidad };
  };

  // Separar préstamos por tipo
  const prestamosCapitalFinal = prestamos.filter(p =>
    p.tipo === 'capital_final' || p.tipo === 'capital_final_fijo'
  );

  const prestamosAmortizados = prestamos.filter(p =>
    p.tipo === 'amortizado' || p.tipo === 'amortizado_frances'
  );

  const otrosPrestamos = prestamos.filter(p =>
    p.tipo !== 'capital_final' &&
    p.tipo !== 'capital_final_fijo' &&
    p.tipo !== 'amortizado' &&
    p.tipo !== 'amortizado_frances'
  );

  const totales = calcularTotales();

  const getBadgeEstado = (estado) => {
    const badges = {
      'activo': 'badge-activo',
      'pagado': 'badge-pagado',
      'atrasado': 'badge-atrasado',
      'vencido': 'badge-vencido',
      'reenganchado': 'badge-reenganchado',
      'refinanciado': 'badge-reenganchado',
      'cerrado': 'badge-cerrado'
    };
    return badges[estado] || 'badge-default';
  };

  const getEstadoColor = (estado) => {
    const colors = {
      'activo': '#27ae60',      // Verde
      'pagado': '#3498db',      // Azul
      'atrasado': '#f39c12',    // Amarillo
      'vencido': '#e74c3c',     // Rojo
      'reenganchado': '#e67e22', // Naranja
      'refinanciado': '#e67e22', // Naranja
      'cerrado': '#95a5a6'      // Gris
    };
    return colors[estado] || '#95a5a6';
  };

  return (
    <div className="reporte-detalle">
      <div className="reporte-header">
        <h1>� Préstamos Realizados</h1>
        <p>Nuevos préstamos otorgados en un período de tiempo</p>
      </div>

      <div className="filtros-container">
        <div className="filtro-grupo">
          <label>Fecha Inicial:</label>
          <input
            type="date"
            value={fechaInicio}
            onChange={(e) => setFechaInicio(e.target.value)}
            className="input-text"
          />
        </div>

        <div className="filtro-grupo">
          <label>Fecha Final:</label>
          <input
            type="date"
            value={fechaFin}
            onChange={(e) => setFechaFin(e.target.value)}
            className="input-text"
          />
        </div>

        <button onClick={cargarPrestamos} className="btn-buscar">
          Buscar
        </button>
      </div>

      {cargando && (
        <div className="loading">Cargando préstamos...</div>
      )}

      {!cargando && prestamos.length > 0 && (
        <>
          <div className="info-prestamo">
            <h3>Período: {formatearFecha(fechaInicio)} - {formatearFecha(fechaFin)}</h3>
            <div className="info-grid">
              <div><strong>Total Préstamos:</strong> {prestamos.length}</div>
              <div><strong>Monto Total:</strong> ${totales.totalPrestado.toFixed(2)}</div>
              <div><strong>Capital a Recibir:</strong> ${totales.totalCapital.toFixed(2)}</div>
              <div><strong>Interés Proyectado:</strong> ${totales.totalInteres.toFixed(2)}</div>
            </div>
          </div>

          <div className="resumen-cards">
            <div className="card-resumen">
              <div className="card-icono">📝</div>
              <div className="card-info">
                <div className="card-valor">{prestamos.length}</div>
                <div className="card-label">Préstamos Otorgados</div>
              </div>
            </div>
            <div className="card-resumen">
              <div className="card-icono">💰</div>
              <div className="card-info">
                <div className="card-valor">${totales.totalPrestado.toFixed(2)}</div>
                <div className="card-label">Total Desembolsado</div>
              </div>
            </div>
            <div className="card-resumen">
              <div className="card-icono">�</div>
              <div className="card-info">
                <div className="card-valor">${totales.totalGeneral.toFixed(2)}</div>
                <div className="card-label">Total a Recaudar</div>
              </div>
            </div>
            <div className="card-resumen">
              <div className="card-icono">📈</div>
              <div className="card-info">
                <div className="card-valor">${totales.totalInteres.toFixed(2)}</div>
                <div className="card-label">Ganancia Proyectada</div>
              </div>
            </div>
          </div>

          {Object.keys(totales.porModalidad).length > 0 && (
            <div className="info-prestamo" style={{ marginTop: '20px' }}>
              <h3>Distribución por Modalidad</h3>
              <div className="info-grid">
                {Object.entries(totales.porModalidad).map(([modalidad, cantidad]) => (
                  <div key={modalidad}>
                    <strong>{modalidad}:</strong> {cantidad} préstamo{cantidad !== 1 ? 's' : ''}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Tabla de Préstamos Capital Final */}
          {prestamosCapitalFinal.length > 0 && (
            <>
              <div style={{ marginTop: '30px', marginBottom: '15px' }}>
                <h2 style={{
                  padding: '12px 20px',
                  background: '#007bff',
                  color: 'white',
                  borderRadius: '8px',
                  margin: 0
                }}>
                  Préstamos capital final
                </h2>
              </div>

              <div className="tabla-container">
                <table className="tabla-reporte">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Nombre</th>
                      <th>Monto</th>
                      <th>Capital</th>
                      <th>Interés</th>
                      <th>Tasa</th>
                      <th>Modalidad</th>
                      <th>Cuotas vencidas</th>
                      <th>Fecha</th>
                      <th>Efectividad</th>
                    </tr>
                  </thead>
                  <tbody>
                    {prestamosCapitalFinal.map(prestamo => (
                      <tr key={prestamo.id}>
                        <td>{prestamo.id}</td>
                        <td>{prestamo.cliente?.nombres || 'N/A'} {prestamo.cliente?.apellidos || ''}</td>
                        <td>DOP {prestamo.total?.toLocaleString('es-DO', {minimumFractionDigits: 0, maximumFractionDigits: 0})}</td>
                        <td>DOP {prestamo.capital?.toLocaleString('es-DO', {minimumFractionDigits: 0, maximumFractionDigits: 0})}</td>
                        <td>DOP {prestamo.interes?.toLocaleString('es-DO', {minimumFractionDigits: 0, maximumFractionDigits: 0})}</td>
                        <td>{prestamo.tasa}%</td>
                        <td>{prestamo.modalidad}</td>
                        <td>{prestamo.cuotas_pagadas || 0}</td>
                        <td>{formatearFecha(prestamo.fecha_inicio)}</td>
                        <td>{formatearFecha(prestamo.fecha_vencimiento)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}

          {/* Tabla de Préstamos Amortizados */}
          {prestamosAmortizados.length > 0 && (
            <>
              <div style={{ marginTop: '30px', marginBottom: '15px' }}>
                <h2 style={{
                  padding: '12px 20px',
                  background: '#007bff',
                  color: 'white',
                  borderRadius: '8px',
                  margin: 0
                }}>
                  Préstamos amortizados
                </h2>
              </div>

              <div className="tabla-container">
                <table className="tabla-reporte">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Nombre</th>
                      <th>Monto</th>
                      <th>Capital</th>
                      <th>Cuota</th>
                      <th>A saldar</th>
                      <th>Tasa</th>
                      <th>Modalidad</th>
                      <th>Dirección</th>
                      <th>Negocio</th>
                      <th>Fecha</th>
                      <th>Efectividad</th>
                    </tr>
                  </thead>
                  <tbody>
                    {prestamosAmortizados.map(prestamo => {
                      const cuota = prestamo.cuotas > 0 ? prestamo.total / prestamo.cuotas : 0;
                      const aSaldar = prestamo.total - (prestamo.monto_cobrado || 0);

                      return (
                        <tr key={prestamo.id}>
                          <td>{prestamo.id}</td>
                          <td>{prestamo.cliente?.nombres || 'N/A'} {prestamo.cliente?.apellidos || ''}</td>
                          <td>DOP {prestamo.total?.toLocaleString('es-DO', {minimumFractionDigits: 0, maximumFractionDigits: 0})}</td>
                          <td>DOP {prestamo.capital?.toLocaleString('es-DO', {minimumFractionDigits: 0, maximumFractionDigits: 0})}</td>
                          <td>DOP {cuota.toLocaleString('es-DO', {minimumFractionDigits: 0, maximumFractionDigits: 0})}</td>
                          <td>DOP {aSaldar.toLocaleString('es-DO', {minimumFractionDigits: 0, maximumFractionDigits: 0})}</td>
                          <td>{prestamo.tasa}%</td>
                          <td>{prestamo.modalidad}</td>
                          <td>{prestamo.cliente?.direccion || 'N/A'}</td>
                          <td>{prestamo.cliente?.negocio || 'N/A'}</td>
                          <td>{formatearFecha(prestamo.fecha_inicio)}</td>
                          <td>{formatearFecha(prestamo.fecha_vencimiento)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          )}

          {/* Tabla de Otros Préstamos (si existen) */}
          {otrosPrestamos.length > 0 && (
            <>
              <div style={{ marginTop: '30px', marginBottom: '15px' }}>
                <h2 style={{
                  padding: '12px 20px',
                  background: '#007bff',
                  color: 'white',
                  borderRadius: '8px',
                  margin: 0
                }}>
                  Otros préstamos
                </h2>
              </div>

              <div className="tabla-container">
                <table className="tabla-reporte">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Nombre</th>
                      <th>Tipo</th>
                      <th>Monto</th>
                      <th>Capital</th>
                      <th>Interés</th>
                      <th>Total</th>
                      <th>Tasa</th>
                      <th>Modalidad</th>
                      <th>Cuotas</th>
                      <th>Estado</th>
                      <th>Fecha</th>
                    </tr>
                  </thead>
                  <tbody>
                    {otrosPrestamos.map(prestamo => (
                      <tr key={prestamo.id}>
                        <td>{prestamo.id}</td>
                        <td>{prestamo.cliente?.nombres || 'N/A'} {prestamo.cliente?.apellidos || ''}</td>
                        <td><span className="badge badge-info">{prestamo.tipo}</span></td>
                        <td>DOP {prestamo.monto_prestado?.toLocaleString('es-DO')}</td>
                        <td>DOP {prestamo.capital?.toLocaleString('es-DO')}</td>
                        <td className="destacado">DOP {prestamo.interes?.toLocaleString('es-DO')}</td>
                        <td><strong>DOP {prestamo.total?.toLocaleString('es-DO')}</strong></td>
                        <td>{prestamo.tasa}%</td>
                        <td>{prestamo.modalidad}</td>
                        <td>{prestamo.cuotas_pagadas}/{prestamo.cuotas}</td>
                        <td>
                          <span 
                            className={`badge ${getBadgeEstado(prestamo.estado)}`}
                            style={{ 
                              backgroundColor: getEstadoColor(prestamo.estado),
                              color: 'white',
                              padding: '0.25rem 0.5rem',
                              borderRadius: '4px',
                              fontSize: '0.85rem',
                              fontWeight: '500'
                            }}
                          >
                            {prestamo.estado}
                            {prestamo.reemplazado_por && (
                              <span style={{ marginLeft: '0.5rem', fontSize: '0.75rem', opacity: 0.9 }}>
                                → #{prestamo.reemplazado_por}
                              </span>
                            )}
                          </span>
                        </td>
                        <td>{formatearFecha(prestamo.fecha_inicio)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </>
      )}

      {!cargando && prestamos.length === 0 && fechaInicio && fechaFin && (
        <div className="sin-datos">
          <p>No se encontraron préstamos en el período seleccionado</p>
        </div>
      )}
    </div>
  );
};

export default PrestamosRealizados;
